
export enum LocalConfigColumn {
    DATE = 'date'
  }
  
  export const localConfigColumns = Object.values(LocalConfigColumn) as string[];